import axios, { AxiosResponse } from 'axios';
import { useSearchStore } from '@/stores/search';
import { IEventSearchApiListResponse } from '@/types/event';
import { ISearchOptions } from '@/types';

export const addFavoriteEvent = (customEventId: string) => {
    return axios.post('/api/favoriteEvent/create', { rows: [{ ceId: customEventId }] });
};

export const removeFavoriteEvent = (customEventId: string) => {
    return axios.post('/api/favoriteEvent/delete', { rows: [{ id: customEventId }] });
};

export const updateOrderFavoriteEvent = (customEventId: string, order: number, orderById: number | null) => {
    return axios.post('/api/favoriteEvent/update', { rows: [{ id: customEventId, order: order, orderById: orderById }] });
};

export const setOrderFavoriteEvent = (orderById: number | null) => {
    return axios.post('/api/favoriteEvent/orderBy', { orderById: orderById });
};

export const clearFavoriteEvents = () => {
    return axios.post('/api/favoriteEvent/clear', {});
};

export const searchEvent = (searchQuery: string, options: ISearchOptions): Promise<AxiosResponse<IEventSearchApiListResponse>> => {
    const searchStore = useSearchStore();

    if (searchStore.ajaxRequest) {
        searchStore.ajaxRequest!.cancel('Canceled due to new request');
    }

    const params = {
        exact: options.exact ?? false,
        caseSensitive: options.caseSensitive ?? false,
    };

    searchStore.ajaxRequest = axios.CancelToken.source();
    return axios.post('/api/search', { searchQuery: searchQuery, options: params }, { cancelToken: searchStore.ajaxRequest.token });
};
